"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JunctionSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.JunctionSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('junction'),
    position: XYPosition_1.XYPositionSchema,
    radiusOverride: zod_1.z.number().optional(),
    net: zod_1.z.coerce.string().optional(),
});
//# sourceMappingURL=Junction.js.map